import { HttpResponse, http, passthrough } from "msw";
import { PlessService } from "../../../app/shared/pless-service.model";
import { getMarkDiv, getManufacturingFactory } from "./kymw6901-handlers";

export const kymw6900Handlers = [
  http.post<unknown, { data: { parameter: { CodeDiv: string; }; }; }>(
    PlessService.SERVICE.KYMW02getCodeList.url,
    async ({ request }) => {
      const req = await request.json();
      if (req.data.parameter.CodeDiv === 'ctp255') {
        return HttpResponse.json(getProposalStatusResponse);
      }
      if (req.data.parameter.CodeDiv === 'ctp267') {
        return HttpResponse.json(getMasterInputStatusResponse);
      }
      if (req.data.parameter.CodeDiv === 'ctp321') {
        return HttpResponse.json(getMarkDiv);
      }
      if (req.data.parameter.CodeDiv === 'ctp268') {
        return HttpResponse.json(getManufacturingFactory);
      }
      return passthrough();
    }
  ),
  http.post(
    PlessService.SERVICE.getProposalId.url,
    () => {
      return HttpResponse.json(getProposalIdResponse);
    }
  ),
  http.post<unknown, { data: { parameter: { ClassCode: string; }; }; }>(
    PlessService.SERVICE.getClassBuyerId.url,
    () => {
      return HttpResponse.json(getClassBuyerIdResponse);
    }
  ),
  http.post<unknown, { data: { parameter: { Page: string; }; }; }>(
    PlessService.SERVICE.getGoodsProposalInfo.url,
    async ({ request }) => {
      const req = await request.json();
      const page = Number(req.data.parameter.Page);
      return HttpResponse.json(getGoodsProposalInfoResponse((page - 1) * 100 + 1, page * 100));
    }
  ),
  http.post<unknown, { data: object; }>(
    PlessService.SERVICE.updateSuggestionStatus.url,
    () => {
      return HttpResponse.json({
        status: 'ok',
        message: '処理完了',
      });
    }
  ),
  http.post(
    PlessService.SERVICE.getSuggestionGoodsOutput.url,
    () => {
      return HttpResponse.json(getSuggestionGoodsOutput);
    }
  )
];

const getProposalStatusResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        CodeDiv: 'ctp255',
        CodeDivName: '提案ステータス',
        CodeValue: '0',
        CodeName: '提案前',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      },
      {
        CodeDiv: 'ctp255',
        CodeDivName: '提案ステータス',
        CodeValue: '1',
        CodeName: '提案中',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      },
      {
        CodeDiv: 'ctp255',
        CodeDivName: '提案ステータス',
        CodeValue: '2',
        CodeName: 'バイヤー採用',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      },
      {
        CodeDiv: 'ctp255',
        CodeDivName: '提案ステータス',
        CodeValue: '3',
        CodeName: 'バイヤー不採用',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      },
      {
        CodeDiv: 'ctp255',
        CodeDivName: '提案ステータス',
        CodeValue: '4',
        CodeName: 'グループ長採用',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      },
      {
        CodeDiv: 'ctp255',
        CodeDivName: '提案ステータス',
        CodeValue: '5',
        CodeName: 'グループ長却下',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      },
    ]
  }
};

const getMasterInputStatusResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        CodeDiv: 'ctp257',
        CodeDivName: 'マスタ入力表',
        CodeValue: '0',
        CodeName: '未登録',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      },
      {
        CodeDiv: 'ctp257',
        CodeDivName: 'マスタ入力表',
        CodeValue: '1',
        CodeName: '登録済',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      },
    ]
  }
};

const getProposalIdResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        AssociatedUserId: '1',
        AssociatedUserName: 'ユーザーA'
      },
      {
        AssociatedUserId: '2',
        AssociatedUserName: 'ユーザーB'
      },
    ]
  }
};

const getClassBuyerIdResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        UserNmKanji: 'バイヤーA',
        UserId: '12',
      },
      {
        UserNmKanji: 'バイヤーB',
        UserId: '13',
      },
    ]
  }
};


const getGoodsProposalInfoResponse = (start: number, end: number) => ({
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      TotalNum: 200,
      StartDispNum: start,
      EndDispNum: end,
      GoodsProposalList: [
        {
          ProposalStatus: '0',
          ProposalUserId: '1',
          ReportOutputDate: '2025/05/15',
          AssociatedUserName: 'ユーザーA',
          ProposalBuyerId: '11',
          UserNmKanji: 'バイヤーA',
          ClassCode: '01',
          ExpansionStartSuggestedOrderCode: '2024010',
          DelivCatalogId: '20240304',
          PCode: 'P1234567',
          ProposalGoodsName: '商品A',
          ProposalName: '規格a',
          MasterInputId: '0',
          ProposalId: '1',
        },
        {
          ProposalStatus: '1',
          ProposalUserId: '2',
          ReportOutputDate: '2025/05/16',
          AssociatedUserName: 'ユーザーB',
          ProposalBuyerId: '12',
          UserNmKanji: 'バイヤーB',
          ClassCode: '02',
          ExpansionStartSuggestedOrderCode: '2024010',
          DelivCatalogId: '20240304',
          PCode: 'P2670365',
          ProposalGoodsName: '商品B',
          ProposalName: '規格b',
          MasterInputId: '1',
          ProposalId: '2',
        },
        {
          ProposalStatus: '2',
          ProposalUserId: '2',
          ReportOutputDate: '',
          AssociatedUserName: '5555555555',
          ProposalBuyerId: '12',
          UserNmKanji: '9999999999',
          ClassCode: '02',
          ExpansionStartSuggestedOrderCode: '2024010',
          DelivCatalogId: '20240304',
          PCode: 'P2670368',
          ProposalGoodsName: 'ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ',
          ProposalName: 'ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ',
          MasterInputId: '1',
          ProposalId: '2',
        },
        {
          ProposalStatus: '3',
          ProposalUserId: '2',
          ReportOutputDate: '',
          AssociatedUserName: '',
          ProposalBuyerId: '12',
          UserNmKanji: '',
          ClassCode: '02',
          ExpansionStartSuggestedOrderCode: '2024010',
          DelivCatalogId: '20240304',
          PCode: 'P0372293',
          ProposalGoodsName: '',
          ProposalName: '',
          MasterInputId: '1',
          ProposalId: '3',
        },
        {
          ProposalStatus: '4',
          ProposalUserId: '3',
          ReportOutputDate: '',
          AssociatedUserName: '髙﨑😀<>',
          ProposalBuyerId: '13',
          UserNmKanji: '髙﨑😀<>',
          ClassCode: '03',
          ExpansionStartSuggestedOrderCode: '2024020',
          DelivCatalogId: '20240311',
          PCode: '',
          ProposalGoodsName: '髙﨑😀<>',
          ProposalName: '髙﨑😀<>',
          MasterInputId: '',
          ProposalId: '4',
        },
        {
          ProposalStatus: '5',
          ProposalUserId: '3',
          ReportOutputDate: '',
          AssociatedUserName: '髙﨑😀<>',
          ProposalBuyerId: '13',
          UserNmKanji: '髙﨑😀<>',
          ClassCode: '03',
          ExpansionStartSuggestedOrderCode: '2024020',
          DelivCatalogId: '20240311',
          PCode: '',
          ProposalGoodsName: '髙﨑😀<>',
          ProposalName: '髙﨑😀<>',
          MasterInputId: '',
          ProposalId: '4',
        },
      ]
    }
  }
});

const getSuggestionGoodsOutput = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      FileUrl: '/tmp/peace/data/WebData/downloadtemp/提案商品一覧表_YYYYMMDD_HHMMSS.xlsx'
    }
  }
};